export default __webpack_public_path__ + "static/media/beep2.1093d4d6.mp3";